var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v(_vm._s(_vm.$t('error.500.heading')))]),_vm._v(" "),_vm._l((_vm.$t('error.500.body')),function(item){return _c('p',{key:item,domProps:{"innerHTML":_vm._s(item)}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }